import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HeaderOptions, MessageObject } from "../typeDefs/common";

export interface CommonState {
    selectedImage: string;
    open: boolean;
    alertsOpen: boolean;
    message: MessageObject;
    sidebarOpen: boolean;
    headerOptions: HeaderOptions;
}

const initialState: CommonState = {
    selectedImage: "",
    open: false,
    alertsOpen: false,
    message: {
        text: "",
        status: "success",
        open: false,
        redirectUrl: undefined,
    },
    sidebarOpen: true,
    headerOptions: {
        title: "",
        large: true,
    },
};

export const commonSlice = createSlice({
    name: "common",
    initialState,
    reducers: {
        setSelectedImage: (state, action: PayloadAction<string>) => {
            state.selectedImage = action.payload;
        },
        setBackdropOpen: (state, action: PayloadAction<boolean>) => {
            state.open = action.payload;
        },
        setMessage: (state, action: PayloadAction<MessageObject>) => {
            state.message = action.payload;
        },
        closeMessage: (state) => {
            state.message = {
                ...state.message,
                open: false,
            };
        },
        openSidebar: (state) => {
            state.sidebarOpen = true;
        },
        closeSidebar: (state) => {
            state.sidebarOpen = false;
        },
        openAlerts: (state) => {
            state.alertsOpen = true;
        },
        closeAlerts: (state) => {
            state.alertsOpen = false;
        },
        setHeaderOptions: (state, action: PayloadAction<HeaderOptions>) => {
            state.headerOptions = action.payload;
        },
    },
});

export const {
    setSelectedImage,
    setBackdropOpen,
    setMessage,
    closeMessage,
    openSidebar,
    closeSidebar,
    openAlerts,
    closeAlerts,
    setHeaderOptions,
} = commonSlice.actions;

export default commonSlice.reducer;
